import { Deserializable } from '../../protocols/deserializable';
import { Asset } from './asset';
import { MediaConvertJobStatus } from '../../enum/dto/media-convert-job-status.enum';
import { GenerateUploadUrlRequest } from '../requests/generate-upload-url-request';
import { MediaUtils } from '../../../utils/media-utils';
import { exists } from '../../../functions/exists';

export class AssetTranscodeStatusUpdate implements Deserializable {
  public assetId: string;
  public status: MediaConvertJobStatus;
  public jobPercentComplete: number;
  public errorMessage: string;
  public asset: Asset | null;
  public metadata: Map<string, string>;

  onDeserialize() {
    this.asset = this.asset ? window?.injector?.Deserialize?.instanceOf(Asset, this.asset) : null;
    this.metadata = window?.injector?.Deserialize?.genericMap(this.metadata) ?? new Map<string, string>();
  }

  public hasAssetWithUniqueId(): boolean {
    return exists(this.asset?.getUniqueIdentifier());
  }

  public isFor(req: GenerateUploadUrlRequest): boolean {
    if (!req?.fileName?.trim()) {
      return false;
    }
    const normalizedFileName = req.fileName?.trim()?.toLowerCase();
    const sanitizedFileName = MediaUtils.getFileNameWithoutTimestamp(normalizedFileName)?.trim()?.toLowerCase();
    const sanitizedFileNameWithoutExtension = MediaUtils.getFileNameWithoutTimestampAndExtension(normalizedFileName)
      ?.trim()
      ?.toLowerCase();
    const inputKey = this.getTranscodeMetadataValue('InputKey');
    if (
      inputKey &&
      (inputKey.includes(normalizedFileName) ||
        (sanitizedFileName && inputKey.includes(sanitizedFileName)) ||
        (sanitizedFileNameWithoutExtension && inputKey.includes(sanitizedFileNameWithoutExtension)))
    ) {
      return true;
    }
    const assetFileName = this.asset?.fileName?.trim()?.toLowerCase();
    if (
      assetFileName &&
      (assetFileName === normalizedFileName ||
        (sanitizedFileName && assetFileName.includes(sanitizedFileName)) ||
        (sanitizedFileNameWithoutExtension && assetFileName.includes(sanitizedFileNameWithoutExtension)))
    ) {
      return true;
    }
    return false;
  }

  public getTranscodeMetadataValue(key: string): string | null {
    return this.metadata?.get(key)?.trim()?.toLowerCase() ?? null;
  }

  completed(): boolean {
    return this.status === MediaConvertJobStatus.Complete;
  }

  errored(): boolean {
    return this.status === MediaConvertJobStatus.Error;
  }

  canceled(): boolean {
    return this.status === MediaConvertJobStatus.Canceled;
  }
}
